export const twitterUrl = 'https://twitter.com/DelovoyDAO';
export const discordUrl = 'https://discord.gg/mgCue3FPyT';
export const telegramUrl = 'https://t.me/DelovoyDAO_chat';
export const mediumUrl = 'https://medium.com/@DelovoyDAO';
